import { useNavigate, useSearchParams } from 'react-router';
import { LoadingSpinner } from '@components/atoms/LoadingSpinner';
import { CommentsForm } from '@components/organisms/CommentsForm';
import { useSample } from '@hooks/useSample';
import { Paths } from '@src/routes/paths';

export const AddSampleCommentView = () => {
  const { data: sample, isLoading } = useSample();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const previousPathParam = searchParams.get('previousPath');
  const previousPath = previousPathParam ?? undefined;

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!sample) {
    navigate(Paths.PROFILE);
    return null;
  }

  return (
    <div>
      <CommentsForm sample={sample} previousPath={previousPath} />
    </div>
  );
};
